import {NavDropdown} from './components/NavDropdown/NavDropdown'
import {NavLink} from './components/NavLink/NavLink'

import {UrlProvider} from './contexts/UrlContext'

import {getMarketingNavigationData} from './marketing-navigation.data'
import type {MarketingNavigationProps} from './marketing-navigation.types'
import styles from './MarketingNavigation.module.css'

export function MarketingNavigation(props: MarketingNavigationProps) {
  const {should_use_dotcom_links: shouldUseDotcomLinks = false} = props

  const data = getMarketingNavigationData()

  return (
    <UrlProvider shouldUseDotcomLinks={shouldUseDotcomLinks}>
      <nav className={styles.nav} aria-label="Global">
        <ul className={styles.list}>
          {data.map(item => (
            <li key={item.title}>
              {'groups' in item ? (
                <NavDropdown {...item} />
              ) : (
                <NavLink {...item} context={item.title} className={styles.navLink} />
              )}
            </li>
          ))}
        </ul>
      </nav>
    </UrlProvider>
  )
}
